import {useReducer, createContext, useEffect, useState} from "react";

export const UserContext = createContext()
export const UserDispatchContext = createContext();


export function reducer(state, action = {}) {
    switch(action.type) {
        case 'name':
            state['name']['value'] = action.payload['value']
            return {...state}

        case 'phone':
            // if(value.length >= state['phone']['value'].length) return;
            state['phone']['value'] = action.payload['value'].replace(/[^0-9]/g, '').replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
            return {...state}

        case 'code':
            state['code']['value'] = action.payload['value']
            return {...state}

        case 'success':
            state[action.payload['key']]['status'] = 1;
            return {...state}

        case 'failed':
            state[action.payload['key']]['status'] = 2;
            return {...state};

        case 'del':
            for(let i in state) {
                state[i]['value'] = ''
            }
            return {...state}

        default:
            return state;
    }
}

const initialState2 = {
    name: {
        id: 0,
        value: '',
        status: 1,
    },
    phone: {
        id: 1,
        value:'',
        status: 1,
        max: 13,
        min: 13,
    },
    code: {
        id: 2,
        value: '',
        status: 2,
        min: 4,
        max: 4,
    }
}

const UserSetting = ({ children }) => {

    const [state, dispatch] = useReducer(reducer, initialState2);

    const dispatchHandler = (key, value) => {
        dispatch({ type: key, payload: { value } })
    }

    const statusSuccessHandler = (key) => {
        dispatch({ type: 'success', payload: { key } })
    }

    const statusFailureHandler = (key) => {
        dispatch({ type: 'failed', payload: { key } })
    }

    const delValueHandler = () => {
        dispatch({ type: 'del' })
    }

    return (
        <UserContext.Provider value={[state]}>
            <UserDispatchContext.Provider value={[dispatchHandler, statusSuccessHandler, statusFailureHandler, delValueHandler]}>
                {children}
            </UserDispatchContext.Provider>
        </UserContext.Provider>
    )
}

export default UserSetting;